import React, { SVGProps } from 'react';

const Edit = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="13"
    viewBox="0 0 12 13"
    fill="none"
    {...props}
  >
    <path
      d="M5.5 2.5H2C1.73478 2.5 1.48043 2.60536 1.29289 2.79289C1.10536 2.98043 1 3.23478 1 3.5V10.5C1 10.7652 1.10536 11.0196 1.29289 11.2071C1.48043 11.3946 1.73478 11.5 2 11.5H9C9.26522 11.5 9.51957 11.3946 9.70711 11.2071C9.89464 11.0196 10 10.7652 10 10.5V7"
      stroke="#4D648B"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.25 1.74999C9.44891 1.55108 9.7187 1.43933 10 1.43933C10.2813 1.43933 10.5511 1.55108 10.75 1.74999C10.9489 1.9489 11.0607 2.21869 11.0607 2.49999C11.0607 2.7813 10.9489 3.05108 10.75 3.24999L6 7.99999L4 8.49999L4.5 6.49999L9.25 1.74999Z"
      stroke="#4D648B"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Edit;
